import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import IProduct from '~/interfaces/IProduct';
import { useCategories } from '~/hooks/categories';
import { useSettings } from '~/hooks/settings';
import { useAuth } from '~/hooks/auth';
import {
  Container,
  ProductsContainer,
  Product,
  SearchContainer,
  Margin,
} from './styles';

import { useProductsCompany } from '../../../../hooks/productsCompany';

let interval: any;

const { REACT_APP_SHOW_SCROLLBAR_POS } = process.env;

const Products: React.FC = () => {
  const searchRef = useRef<HTMLInputElement>(null);

  const { categorySelected, selectProduct, products } = useProductsCompany();
  const [search, setSearch] = useState('');

  const { company } = useAuth();
  const { complements, categories, loadComplements, loadCategories } =
    useCategories();

  const [init, setInit] = useState(false);

  useEffect(() => {
    if (
      !init &&
      company.uid &&
      (complements.length === 0 || categories.length === 0)
    ) {
      loadComplements(company.uid);
      loadCategories(company.uid);
      setInit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, init, loadComplements, loadCategories]);

  const filtered = useMemo(() => {
    let productsFilter = [] as IProduct[];

    if (search) {
      productsFilter = products.filter(item =>
        item.name.toLocaleLowerCase().includes(search.toLowerCase()),
      );
    } else {
      if (!categorySelected) return [];

      productsFilter = products.filter(
        item => item.category.uid === categorySelected.uid,
      );
    }

    productsFilter = productsFilter.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase()
        ? 1
        : b.name.toLowerCase() > a.name.toLowerCase()
        ? -1
        : 0,
    );

    return productsFilter;
  }, [search, categorySelected, products]);

  const handleChangeSearch = useCallback(() => {
    if (interval) clearInterval(interval);

    interval = setInterval(() => {
      if (searchRef.current) {
        setSearch(searchRef.current.value);
      }
    }, 300);
  }, []);

  const handleClearSearch = useCallback(() => {
    if (searchRef.current) {
      searchRef.current.value = '';
    }

    setSearch('');
  }, []);

  const handleAddProduct = useCallback(
    (item: IProduct) => {
      selectProduct(item);

      // if (item.complements_list && item.complements_list.length > 0) {
      //   setProductSelected(item);
      // } else {
      //   const product = {
      //     ...item,
      //     quantity: 1,
      //   } as IProductCart;

      //   add(product);
      // }
    },
    [selectProduct],
  );

  return (
    <Container>
      <SearchContainer>
        <div>
          <span>
            <i className="fa fa-search" />
          </span>
          <input
            ref={searchRef}
            type="text"
            placeholder="Pesquisar...."
            onChange={handleChangeSearch}
          />
          {search.length > 0 && (
            <button onClick={handleClearSearch}>
              <i className="bx bx-x" />
            </button>
          )}
        </div>
      </SearchContainer>
      <ProductsContainer showScrollbar={!!REACT_APP_SHOW_SCROLLBAR_POS}>
        {filtered.map(item => (
          <Product key={item.uid} onClick={() => handleAddProduct(item)}>
            {item.image && <img src={item.image} alt="Ilustracao" />}

            {item.enable_promotion && (
              <span
                className="badge badge-success ml-1"
                style={{
                  position: 'absolute',
                  top: 6,
                  left: 0,
                }}
              >
                Promoção
              </span>
            )}

            <p>
              <span>{item.category.name}</span>
              <br />
              <strong>{item.name}</strong>
            </p>
            <span>
              {Number(
                item.enable_promotion ? item.value_promotion : item.value,
              ).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}

              {item.enable_promotion && (
                <span
                  className="ml-1"
                  style={{ fontSize: 10, textDecoration: 'line-through' }}
                >
                  {Number(item.value).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </span>
              )}
            </span>
          </Product>
        ))}

        <Margin />
      </ProductsContainer>
    </Container>
  );
};

export default Products;
